import React, { createContext, useContext, useState, ReactNode } from "react";

interface ContractContextType {
  contractUpdated: boolean;
  triggerContractUpdate: () => void;
  resetContractUpdate: () => void;
}

const ContractContext = createContext<ContractContextType | undefined>(
  undefined,
);

export const useContractContext = () => {
  const context = useContext(ContractContext);
  if (!context) {
    throw new Error(
      "useContractContext must be used within a ContractProvider",
    );
  }
  return context;
};

interface ContractProviderProps {
  children: ReactNode;
}

export const ContractProvider: React.FC<ContractProviderProps> = ({
  children,
}) => {
  const [contractUpdated, setContractUpdated] = useState(false);

  const triggerContractUpdate = () => {
    setContractUpdated(true);
  };

  const resetContractUpdate = () => {
    setContractUpdated(false);
  };

  return (
    <ContractContext.Provider
      value={{
        contractUpdated,
        triggerContractUpdate,
        resetContractUpdate,
      }}
    >
      {children}
    </ContractContext.Provider>
  );
};
